// extracted by mini-css-extract-plugin
export default {"fullWidth":"wo-z","image":"xo-z","lazyLoadPicture":"yo-z","lazyLoadSpinner":"zo-z","lazyLoadSpin":"Ao-z","lazyLoadImage":"Bo-z","hasStyledAspectRatio":"Co-z"};